// Use it to check events and when tracking started
export const IS_DEBUG_ANALYTICS = false;
